import React from 'react';
import { MessageInputFlat } from 'stream-chat-react';

interface CustomInputProps {}

export const CustomInput = (props: CustomInputProps) => {
  return <MessageInputFlat />;
};
